/* eslint-disable no-console */
const contentToggle = () => {
  // Elements
  const mobileSubmenus = document.querySelectorAll('.content-toggle-button');

  const toggleMobileSubMenuState = (btn, state) => {
    const parent = btn.parentNode;
    if (state) {
      btn.classList.remove('toggle-open', 'btn-text-change');
      parent.querySelector('.toggle-content').classList.remove('open', 'fade-in-down');
    } else {
      btn.classList.add('toggle-open', 'btn-text-change');
      parent.querySelector('.toggle-content').classList.add('open', 'fade-in-down');
    }
  };

  // Toggle Mobile Submenus
  if (mobileSubmenus) {
    [].map.call(mobileSubmenus, btn => btn.addEventListener('click', (event) => {
      event.preventDefault();
      toggleMobileSubMenuState(btn, btn.classList.contains('toggle-open'));
    }));
  }
};

export default contentToggle;
/* eslint-enable no-console */
